"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var ramda_1 = require("ramda");
var html_1 = __importDefault(require("./html"));
var react_1 = __importDefault(require("./react"));
var tag_1 = __importDefault(require("./tag"));
var WHITE_LIST = ['disabled'];
var extraProps = function (props, sanitizedProps) { return ramda_1.difference(ramda_1.keys(ramda_1.omit(WHITE_LIST, props)), ramda_1.keys(sanitizedProps)); };
/**
 * Remove all extra props that is not w3c compliant.
 *
 * @param {String|Function|Array} tag The react element type
 * @param {Array} filters The extra propNames to remove from props
 * @param {Object} props The props to cleans
 */
var sanitizeProps = ramda_1.curry(function (tag, filters, props) {
    var filteredProps = ramda_1.omit(filters || [], props);
    // We clean props only when we render a dom component
    if (!ramda_1.is(String, tag)) {
        return filteredProps;
    }
    var tagSanitizer = tag_1["default"][tag];
    var sanitizedProps = __assign(__assign(__assign({}, html_1["default"](filteredProps)), react_1["default"](filteredProps)), (tagSanitizer && tagSanitizer(filteredProps)));
    var diff = extraProps(filteredProps, sanitizedProps);
    if (ramda_1.length(diff)) {
        // eslint-disable-next-line no-console
        console.warn("This props are not w3c valid for \"" + tag + "\" tag : ", diff);
    }
    // Returns sanitizedProps to force filters
    // return sanitizedProps;
    return filteredProps;
});
exports["default"] = sanitizeProps;
//# sourceMappingURL=sanitize-props.js.map